import React, { useState, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './BaseLayout.module.scss';

import { IBaseLayoutProps } from './interface';

// Components
import AgeGate from '../AgeGate';
import Screensaver from '../Screensaver';

import { config } from '../../../utils/config';
import { useAppSelector } from '../../../app/hooks';

const BaseLayout: React.FC<IBaseLayoutProps> = (props: IBaseLayoutProps) => {
    const { children } = props;
    const sessionToken = useAppSelector((state) => state.users.sessionToken);

    // Campania DELIA: pe ruta de index se afișează landing page-ul, care își aduce
    // propriul fundal, propriul <h1> și propriul disclaimer legal. Titlul sr-only
    // al layout-ului este ascuns acolo, ca să nu existe două <h1> pe pagină.
    const { pathname } = useLocation();
    const isCampaignLP = pathname === config.path.index;

    const [key, setKey] = useState(0);
    const handleScreensaverStateChange = useCallback(() => {
        setKey((prevKey) => prevKey + 1);
    }, []);

    useEffect(() => {
        if (sessionToken === null) handleScreensaverStateChange();
    }, [sessionToken]);

    return (
        <div className={styles.wrapper}>
            {!isCampaignLP && (
                <header className="sr-only">
                    <h1>Trăiește aventuri electrizante.</h1>
                </header>
            )}
            <main>
                <React.Fragment key={key}>{children}</React.Fragment>
            </main>
            {/*<BaseFooter internalLayout={true} />*/}

            {/*<AgeGate />*/}
            <Screensaver onStateChange={handleScreensaverStateChange} />
        </div>
    );
};

export default BaseLayout;
